import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from '../locales/en.json';
import ar from '../locales/ar.json';

// Deep-merge plain objects. Later sources win on leaf conflicts.
type Dict = Record<string, any>;
function deepMerge(target: Dict, source: Dict): Dict {
  for (const key of Object.keys(source)) {
    const sv = source[key];
    const tv = target[key];
    if (sv && typeof sv === 'object' && !Array.isArray(sv) && tv && typeof tv === 'object' && !Array.isArray(tv)) {
      deepMerge(tv, sv);
    } else {
      target[key] = sv;
    }
  }
  return target;
}

// Auto-collect per-area translation fragments so translation work can be split
// across many files without merge conflicts. Each fragment file lives in
// `../locales/fragments/` and is named `<area>.en.json` / `<area>.ar.json`.
const enFragments = import.meta.glob('../locales/fragments/*.en.json', { eager: true, import: 'default' }) as Record<string, Dict>;
const arFragments = import.meta.glob('../locales/fragments/*.ar.json', { eager: true, import: 'default' }) as Record<string, Dict>;

const enResources: Dict = deepMerge({ ...en } as Dict, {});
for (const frag of Object.values(enFragments)) deepMerge(enResources, frag);

const arResources: Dict = deepMerge({ ...ar } as Dict, {});
for (const frag of Object.values(arFragments)) deepMerge(arResources, frag);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enResources },
      ar: { translation: arResources }
    },
    supportedLngs: ['en', 'ar'],
    fallbackLng: 'en',
    load: 'languageOnly',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng'
    }
  });

export default i18n;
